<template>
  <div class="error404">
    <p> page not found :(</p>
    <router-link to="/">
      back to main
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'NotFoundComponent'
  }
</script>

<style scoped>

</style>
